<template>
    <div class="apprentice-simple-card">
        <design-2021-questionnaire-component :project-id="projectId" :questionnaire-in="questionnaire"></design-2021-questionnaire-component>
    </div>
</template>

<script>
    export default {
        name: "design-2021-project-show-questionnaire-component",
        props: ['projectId', 'questionnaire']
    }
</script>

<style scoped>
</style>
